import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  deleteSelectedCollectionFilter,
  clearAllCollectionFiltersAndReload,
  clearCollectionFilters,
  clearSelectedCollectionFilters,
  refreshCollections,
} from '../../actions/Collections';

import PinnedSearchesTags from '../Search/PinnedSearchesTags';
import PinnedSearchesIcons from '../Search/PinnedSearchesIcons';
import PinCreateSmartCollection from '../Search/PinCreateSmartCollection';

import { handleURLParamsRemove } from '../../helpers/URLParams';
import { getTagTitle } from '../../helpers/Search';

class CollectionsFilters extends PureComponent {
  constructor(props) {
    super(props);

    this.removeFilterWrapper = this.removeFilterWrapper.bind(this);
  }

  componentWillUnmount() {
    const { clearAllFilters } = this.props;
    clearAllFilters();
  }

  removeFilterWrapper(type, key) {
    const { removeFilter, history } = this.props;
    handleURLParamsRemove(type, key, history);
    removeFilter(type, key);
  }

  render() {
    const {
      intl,
      selectedFilters,
      clearFilters,
    } = this.props;

    if (selectedFilters.length === 0) {
      return null;
    }

    return (
      <div className="active-filters tags-list">
        <PinCreateSmartCollection
          selectedFilters={selectedFilters}
          type="collections"
        />
        <PinnedSearchesTags
          selectedFilters={selectedFilters}
          clearFilters={clearFilters}
          type="collections"
        />
        {selectedFilters.map((sf, idx) => (
          <div className="tag" key={`${sf.type}-${sf.key}`} title={getTagTitle(sf)}>
            <span className="tag-label">
              {sf.label}
            </span>
            {/* eslint-disable jsx-a11y/click-events-have-key-events */}
            <span
              className="tag-remove"
              title={intl.formatMessage({ defaultMessage: 'Remove' })}
              role="button"
              tabIndex={idx}
              onClick={() => { this.removeFilterWrapper(sf.type, sf.key); }}
            >
              <i className="far fa-times" />
            </span>
            {/* eslint-enable jsx-a11y/click-events-have-key-events */}
          </div>
        ))}
        <PinnedSearchesIcons
          selectedFilters={selectedFilters}
          type="collections"
        />
        <Button color="link" size="sm" onClick={clearFilters}>
          {intl.formatMessage({ defaultMessage: 'Clear all' })}
        </Button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectedFilters: state.Collections.selectedFilters,
});

const mapDispatchToProps = dispatch => ({
  removeFilter: (filterType, filterKey) => {
    dispatch(deleteSelectedCollectionFilter(filterType, filterKey));
    dispatch(refreshCollections());
  },
  clearFilters: () => {
    dispatch(clearAllCollectionFiltersAndReload());
  },
  clearAllFilters: () => {
    dispatch(clearCollectionFilters());
    dispatch(clearSelectedCollectionFilters());
  },
});

CollectionsFilters.propTypes = {
  intl: PropTypes.object.isRequired,
  selectedFilters: PropTypes.array.isRequired,
  removeFilter: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  clearAllFilters: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(
  injectIntl(connect(mapStateToProps, mapDispatchToProps)(CollectionsFilters)),
);
